import { registerPlugin } from '@capacitor/core';

import { isIOS } from 'utils/environment';

interface ILocationPermissionsPlugin {
  getAuthorizationStatus: () => Promise<{ status: string }>;
}

export const LocationPermissionsPlugin = isIOS()
  ? registerPlugin<ILocationPermissionsPlugin>('LocationPermissionsPlugin')
  : null;
